"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostModel = void 0;
var User_1 = require("./User");
var PostModel = /** @class */ (function () {
    function PostModel() {
        this.PostId = '';
        this.PostUser = new User_1.UserModel();
        this.PostTime = '';
        this.PostBody = '';
        this.PostImageLocation = '';
        this.SendEmailNotificationInd = true;
        this.PostImmediatelyInd = true;
        this.PostFutureTime = '';
    }
    return PostModel;
}());
exports.PostModel = PostModel;
;
//# sourceMappingURL=Post.js.map